import { Icon } from '@toggle/design-system';
import { Entity, formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { TruncateTooltip } from '~/components/truncate-tooltip/TruncateTooltip';
import { MAX_TICKER_DISPLAY_LENGTH } from '~/stores/use-watchlist/constants';

import styles from './CompanyNameCell.module.scss';

export const CompanyNameCell = ({
  entity,
  showAlertIcon = false,
}: {
  entity: Entity;
  showAlertIcon?: boolean;
}) => {
  const { t } = useTranslation('common');

  if (!entity.id) {
    return (
      <span
        className={styles.styledTextNa}
        data-testid="table-cell-empty-value"
      >
        {t('common:table.na')}
      </span>
    );
  }

  return (
    <div className={styles.root}>
      <div className={styles.flexRowWrapper}>
        <div className={styles.iconsContainer}>
          <AssetLogoContainer entity={entity} size={32} />
          {showAlertIcon && (
            <div className={styles.iconContainer}>
              <Icon
                className={styles.styledIcon}
                iconName="ExclamationCircle"
                fillColor="var(--icon-critical)"
                strokeColor="var(--background-soft)"
                size={16}
              />
            </div>
          )}
        </div>
        <div className={styles.companyNameContainer}>
          <TruncateTooltip
            text={entity.name}
            atLength={MAX_TICKER_DISPLAY_LENGTH}
          />
          <p className={styles.tag}>{formatTicker(entity)}</p>
        </div>
      </div>
    </div>
  );
};
